import { useState } from 'react';
import './Header.css';
import logo from '../../images/viacool_logo.png';
import { FaHome, FaLinkedin } from 'react-icons/fa';
import { IoLogoYoutube } from "react-icons/io";


function Header() {
    const [mobileMenu, setMobileMenu] = useState(false);

    return (
        <>
            <header>
                <div className='header-wrapper'>
                    <div>
                        <img src={logo} alt="Logo" />
                    </div>
                    <nav className='header-nav'>
                        <div>
                            <ul>
                                <li><a href="#problem">problem</a></li>
                                <li><a href="#solution">solution</a></li>
                                <li><a href="#about">about us</a></li>
                                <li><a href="#team">team</a></li>
                                <li><a href="#contact">contact</a></li>
                            </ul>
                        </div>
                        <div className='header-nav-icons'>
                            <span className='nav-icons'>
                                <FaHome />
                            </span>
                            <span className='nav-icons'>
                                <FaLinkedin />
                            </span>
                            <span className='nav-icons'>
                                <IoLogoYoutube />
                            </span>
                        </div>
                    </nav>

                    <div className="menu-btn-container" onClick={() => setMobileMenu(!mobileMenu)}>
                        <span className={`menu-line ${mobileMenu && "hamburger-first-child"}`}></span>
                        <span className={`menu-line ${mobileMenu && "middle-hamburger-hide"}`}></span>
                        <span className={`menu-line ${mobileMenu && "hamburger-last-child"}`}></span>
                    </div>
                </div>
            </header>

            {mobileMenu && (
                <div className={`mobile-nav}`}>
                    <div className='mobile-menu-wrapper'>
                        <a onClick={() => setMobileMenu(false)} href="#problem" className='animate-link' noreferrer>problem</a>
                        <a onClick={() => setMobileMenu(false)} href="#solution" className='animate-link' noreferrer>solution</a>
                        <a onClick={() => setMobileMenu(false)} href="#about" className='animate-link' noreferrer>about us</a>
                        <a onClick={() => setMobileMenu(false)} href="#team" className='animate-link' noreferrer>team</a>
                        <a onClick={() => setMobileMenu(false)} href="#contact" className='animate-link' noreferrer>contact</a>
                        <div className='header-nav-icons-mobile'>
                            <span className='nav-icons'>
                                <FaHome />
                            </span>
                            <span className='nav-icons'>
                                <FaLinkedin />
                            </span>
                            <span className='nav-icons'>
                                <IoLogoYoutube />
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Header;
